import React from 'react';
import { useForm } from 'react-hook-form';
import { usePushEvents } from '../../../../hooks/PushEvents';
import {
    loginPopupPasswordScreenNext,
    loginPopupPasswordScreenShown,
} from '../../../../hooks/PushEvents/clevertapEvents';

export type PasswordFormValues = {
    password: string;
};

export const usePasswordStep = (
    onPasswordSubmit: (password: string) => void,
) => {
    const { pushEvent } = usePushEvents();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<PasswordFormValues>();

    const [showPassword, setShowPassword] = React.useState(false);

    const toggleShowPassword = React.useCallback(
        () => setShowPassword((s) => !s),
        [],
    );

    React.useEffect(() => {
        pushEvent(loginPopupPasswordScreenShown);
        // run only once when component is mounted
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmit = handleSubmit((data) => {
        pushEvent(loginPopupPasswordScreenNext);
        onPasswordSubmit(data.password);
    });

    return {
        register,
        errors,
        showPassword,
        toggleShowPassword,
        onSubmit,
    };
};
